document.addEventListener('DOMContentLoaded', () => {
    const playerWrapper = document.getElementById('customVideoPlayer');
    const video = document.getElementById('productVideo');
    const playPauseBtn = document.getElementById('playPauseButton');
    const playIcon = document.getElementById('playIcon');
    const pauseIcon = document.getElementById('pauseIcon');
    // const timelineContainer = playerWrapper.querySelector('.timeline-container');
    // const timelineBackground = document.getElementById('timelineBackground');
    // const timelineProgress = document.getElementById('timelineProgress');
    // const timelineScrubber = document.getElementById('timelineScrubber');

    let isScrubbing = false;
    let hideControlsTimeout;

    // --- Функціональність Play/Pause ---

    const togglePlayPause = () => {
        if (video.paused || video.ended) {
            video.play();
        } else {
            video.pause();
        }
    };

    playPauseBtn.addEventListener('click', togglePlayPause);
    video.addEventListener('click', togglePlayPause); // Дозволяємо клік по відео

    video.addEventListener('play', () => {
        playerWrapper.classList.remove('paused');
        playerWrapper.classList.add('playing');
        playIcon.classList.add('hidden');
        pauseIcon.classList.remove('hidden');
        resetControlsTimeout();
    });

    video.addEventListener('pause', () => {
        playerWrapper.classList.remove('playing');
        playerWrapper.classList.add('paused');
        playIcon.classList.remove('hidden');
        pauseIcon.classList.add('hidden');
        clearTimeout(hideControlsTimeout);
        showControls();
    });

    video.addEventListener('ended', () => {
        playerWrapper.classList.remove('playing');
        playerWrapper.classList.add('paused');
        playIcon.classList.remove('hidden');
        pauseIcon.classList.add('hidden');
        video.currentTime = 0; // Скидаємо відео на початок
        showControls();
    });

    // Ініціалізація стану на початку
    if (video.paused) {
        playerWrapper.classList.add('paused');
    }

    // --- Оновлення Таймлайну ---

    // video.addEventListener('timeupdate', () => {
    //     if (!isScrubbing) {
    //         const progress = (video.currentTime / video.duration) * 100;
    //         timelineProgress.style.width = `${progress}%`;
    //     }
    // });

    // --- Логіка Таймлайн: Перетягування (Скраббінг) ---

    // const setVideoTime = (e) => {
    //     const rect = timelineBackground.getBoundingClientRect();
    //     let clientX;

    //     // Визначаємо позицію кліку/дотику
    //     if (e.touches) {
    //         clientX = e.touches[0].clientX;
    //     } else {
    //         clientX = e.clientX;
    //     }

    //     let newPosition = (clientX - rect.left) / rect.width;

    //     // Обмежуємо позицію від 0 до 1
    //     newPosition = Math.max(0, Math.min(1, newPosition));

    //     const newTime = newPosition * video.duration;

    //     // Оновлюємо лише візуальний прогрес під час скраббінгу
    //     if (isScrubbing) {
    //         timelineProgress.style.width = `${newPosition * 100}%`;
    //     } else {
    //         // При звичайному кліку - одразу встановлюємо час
    //         video.currentTime = newTime;
    //     }
    // };

    // const startScrubbing = (e) => {
    //     if (video.duration) {
    //         isScrubbing = true;
    //         video.pause(); // Пауза на час перемотки
    //         timelineContainer.classList.add('expanded'); // Розширюємо таймлайн під час перемотки
    //         playerWrapper.classList.add('touch-active'); // Підтримуємо відображення елементів керування
    //         setVideoTime(e); // Встановлюємо початковий час

    //         document.addEventListener('mousemove', setVideoTime);
    //         document.addEventListener('mouseup', endScrubbing);
    //         document.addEventListener('touchmove', setVideoTime);
    //         document.addEventListener('touchend', endScrubbing);
    //     }
    // };

    // const endScrubbing = () => {
    //     if (isScrubbing) {
    //         isScrubbing = false;
    //         // Встановлюємо фактичний час відео після завершення скраббінгу
    //         const progress = parseFloat(timelineProgress.style.width) / 100;
    //         video.currentTime = progress * video.duration;
    //         video.play(); // Продовжуємо відтворення
    //         timelineContainer.classList.remove('expanded');
    //         playerWrapper.classList.remove('touch-active');
    //         resetControlsTimeout(); // Скидаємо таймер приховування
    //     }
    //     document.removeEventListener('mousemove', setVideoTime);
    //     document.removeEventListener('mouseup', endScrubbing);
    //     document.removeEventListener('touchmove', setVideoTime);
    //     document.removeEventListener('touchend', endScrubbing);
    // };

    // // Слухачі подій для початку скраббінгу (Миша та Тач)
    // timelineBackground.addEventListener('mousedown', startScrubbing);
    // timelineBackground.addEventListener('touchstart', startScrubbing, { passive: true });

    // --- Логіка Відображення Елементів Керування (Таймлайн та Кнопка) ---

    const showControls = () => {
        playerWrapper.classList.add('touch-active');
        // timelineContainer.classList.remove('minimized');
        // timelineContainer.classList.add('expanded');
        // На відміну від CSS :hover, клас touch-active буде керуватися JS для мобільних
    };

    const hideControls = () => {
        if (!video.paused) {
            // timelineContainer.classList.add('minimized');
            // timelineContainer.classList.remove('expanded');
            playerWrapper.classList.remove('touch-active');
        }
    };

    const resetControlsTimeout = () => {
        showControls();
        clearTimeout(hideControlsTimeout);
        if (!video.paused) {
            // clearTimeout(hideControlsTimeout);
            // showControls();
            hideControlsTimeout = setTimeout(hideControls, 1000); // Приховати через 1 секунду бездіяльності
        }
    };

    // Для десктопу (наведення миші)
    // playerWrapper.addEventListener('mouseenter', showControls);
    playerWrapper.addEventListener('mousemove', resetControlsTimeout);
    playerWrapper.addEventListener('mouseleave', hideControls);

    // Для мобільних (натискання пальцем / тач)
    playerWrapper.addEventListener('touchstart', () => {
        if (playerWrapper.classList.contains('touch-active')) {
            // Якщо панель вже відкрита, просто оновлюємо таймер
            resetControlsTimeout();
        } else {
            // Якщо закрита — показуємо
            showControls();
            resetControlsTimeout();
        }
    }, { passive: true });

    // Приховати таймлайн після завантаження, якщо відео не на паузі
    video.addEventListener('loadedmetadata', () => {
        if (video.playing) {
            hideControls();
        }
    });
});